export default function ServeBox({ serving, children, className = "", testid, size = "sm" }) {
  if (!serving) return <div className={className} data-testid={testid}>{children}</div>;
  const tag = size === "lg" ? "text-xs px-2 py-0.5" : "text-[8px] px-1.5 py-px";
  return (
    <div className={`serve-box relative px-2 py-1 -mx-2 ${className}`} data-testid={testid} data-serving="true">
      {children}
      <span className={`absolute -top-2 right-1 bg-black text-red-400 font-black uppercase tracking-widest leading-none ${tag}`} data-testid={testid ? `${testid}-serve-tag` : undefined}>Serve</span>
    </div>
  );
}
